import React from 'react'
import './index.scss'
import AvatarComponent from '@Components/AvatarComponent'
import TagComponent from '@Components/Tag'
import { UserGroup, UserInfo } from '@Entities/user/user'
import { UserInfoType } from '@Entities/schemas/user/user-info-schema'

interface IProps {
    userInfo: Partial<UserInfoType> | Partial<UserInfo>
}

const UserInfoAvatar = (props: IProps) => {
    const { firstName, lastName, groups, email, verificationStatus } = props.userInfo

    return (
        <div className="user-info-avatar-component">
            <AvatarComponent firstName={firstName ? firstName : 'NoData'} lastName={lastName ? lastName : 'NoData'} />
            <div className="info">
                <h5 title={firstName + ' ' + lastName}>
                    {firstName} {lastName}
                </h5>
                {groups && groups.length ? (
                    <div className="tags">
                        {groups &&
                            groups.map((item: UserGroup) => (
                                <TagComponent key={item.name} type="primary" name={item.name} />
                            ))}
                    </div>
                ) : null}
                <div>
                    {email ? (
                        <p className="small">
                            Email: <span>{email}</span>
                        </p>
                    ) : null}
                    {verificationStatus ? (
                        <p className="small">
                            Status: <span>{verificationStatus}</span>
                        </p>
                    ) : null}
                </div>
            </div>
        </div>
    )
}

export default UserInfoAvatar
